import { compose, map, keys } from "ramda"

export const scheduleTypeMap = {
  DAILY: "general.daily",
  WEEKLY: "general.weekly",
  MONTHLY: "general.monthly",
  RUN_ONCE: "general.runOnce",
  RUN_IMMEDIATELY: "general.runOnceImmediately",
  NO_SCHEDULE: "general.none",
  INTERVAL: "general.every",
  ON_SYSTEM_STARTUP: "general.onSystemStartup",
  ON_USER_LOGIN: "general.onUserLogin",
}

export const intervalOptions = [
  { value: "HOUR", labelToken: "general.hours" },
  { value: "MINUTE", labelToken: "general.minutes" },
]

export const scheduleTypeOptions = compose(
  map(value => ({
    value,
    labelToken: scheduleTypeMap[value],
  })),
  keys,
)(scheduleTypeMap)

export const defaultAgentSchedule = {
  scheduleType: "DAILY",
  weekDays: [],
  dayOfMonth: 0,
  scheduleHour: 17,
  scheduleMinute: 0,
  timeZone: "_Local",
}
